import { useQuery } from '@tanstack/react-query';

import APIGateway from '@/api';
import { ByoaAgent } from '@/types/agent';

export const byoaAgentsKeys = {
  all: [ 'byoaAgents' ] as const,
  list: () => [ ...byoaAgentsKeys.all, 'list' ] as const,
  detail: ( agentName: string ) => [ ...byoaAgentsKeys.all, 'detail', agentName ] as const
};

export function useByoaAgentsQuery( enabled: boolean = true ) {
  return useQuery( {
    queryKey: byoaAgentsKeys.list(),
    queryFn: async() => {
      try {
        const { agents } = await APIGateway.byoaAgents.byoaAgentsGet();
        return agents ?? [];
      } catch {
        return [];
      }
    },
    enabled
  } );
}

export function useByoaAgentQuery( agentId: string | undefined, refetchInterval?: number, initialData?: ByoaAgent ) {
  return useQuery( {
    queryKey: byoaAgentsKeys.detail( agentId! ),
    queryFn: async() => {
      return await APIGateway.byoaAgents.byoaAgentGet( agentId! );
    },
    enabled: !!agentId,
    refetchInterval,
    initialData
  } );
}
